module.exports = __webpack_public_path__ + "img/a1.e8a51839.png";